// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Request body for the channel quick-enable/disable toggle
 *  (`PATCH /channels/:channelID/active`).
 *
 * The channel ID comes from the URL
 * path, not this body. Unlike `Channel` above (used by the create/update
 * endpoints, which are NOT true partial updates — every field present in
 * the wire message overwrites its column), this is a true partial update:
 * the handler touches only the `active` column and leaves every other
 * field on the row untouched.
 */
export class ChannelActiveRequest implements flatbuffers.IUnpackableObject<ChannelActiveRequestT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ChannelActiveRequest {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsChannelActiveRequest(
    bb: flatbuffers.ByteBuffer,
    obj?: ChannelActiveRequest,
  ): ChannelActiveRequest {
    return (obj || new ChannelActiveRequest()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsChannelActiveRequest(
    bb: flatbuffers.ByteBuffer,
    obj?: ChannelActiveRequest,
  ): ChannelActiveRequest {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ChannelActiveRequest()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startChannelActiveRequest(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(0, +active, +false);
  }

  static endChannelActiveRequest(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createChannelActiveRequest(
    builder: flatbuffers.Builder,
    active: boolean,
  ): flatbuffers.Offset {
    ChannelActiveRequest.startChannelActiveRequest(builder);
    ChannelActiveRequest.addActive(builder, active);
    return ChannelActiveRequest.endChannelActiveRequest(builder);
  }

  unpack(): ChannelActiveRequestT {
    return new ChannelActiveRequestT(this.active());
  }

  unpackTo(_o: ChannelActiveRequestT): void {
    _o.active = this.active();
  }

  unpackFields(...fields: string[]): ChannelActiveRequestT {
    const t = new ChannelActiveRequestT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    return t;
  }
}

export class ChannelActiveRequestT implements flatbuffers.IGeneratedObject {
  constructor(public active: boolean = false) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return ChannelActiveRequest.createChannelActiveRequest(builder, this.active);
  }

  clone(): ChannelActiveRequestT {
    const obj = new ChannelActiveRequestT();
    obj.active = this.active;
    return obj;
  }

  equals(other: ChannelActiveRequestT): boolean {
    if (this.active !== other.active) return false;
    return true;
  }
}

export function verifyChannelActiveRequest(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
  } finally {
    verifier.popDepth();
  }
}
